import React, { useState } from "react";
import PartnerHeader from "../../component/PartnerHeader";
import PartnerFooter from "../../component/PartnerFooter";

function PartnerNotifications() {
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      title: "Trainer Application Received",
      message:
        "Rahul Sharma applied for your Java DSA job.",
      time: "10 minutes ago",
      read: false,
    },
    {
      id: 2,
      title: "Job Approved",
      message:
        "Your Java DSA job has been approved.",
      time: "2 hours ago",
      read: true,
    },
    {
      id: 3,
      title: "Training Request",
      message:
        "New training request has been received.",
      time: "Yesterday",
      read: false,
    },
  ]);

  const markRead = (id) => {
    setNotifications((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, read: true }
          : item
      )
    );
  };

  return (<>
  <PartnerHeader/>
    <div className="page">
      <h1>Notifications</h1>
      <p>Latest updates and notifications.</p>

      <div className="notification-list">
        {notifications.map((item) => (
          <div
            className={`notification ${
              item.read ? "read" : "unread"
            }`}
            key={item.id}
            onClick={() => markRead(item.id)}
          >
            <div className="icon">🔔</div>

            <div className="content">
              <h3>{item.title}</h3>

              <p>{item.message}</p>

              <small>{item.time}</small>
            </div>

            {!item.read && (
              <span className="dot"></span>
            )}
          </div>
        ))}
      </div>

      <style>{`
        .page {
          padding:30px;
          background:#f8fafc;
          min-height:100vh;
        }

        .page > p {
          color:#64748b;
        }

        .notification-list {
          margin-top:25px;
          max-width:900px;
        }

        .notification {
          display:flex;
          align-items:flex-start;
          gap:15px;
          padding:18px;
          margin-bottom:10px;
          border-radius:10px;
          background:white;
          cursor:pointer;
          box-shadow:0 3px 12px rgba(0,0,0,.05);
          position:relative;
        }

        .unread {
          border-left:4px solid #2563eb;
        }

        .read {
          opacity:.75;
        }

        .icon {
          width:40px;
          height:40px;
          border-radius:50%;
          background:#dbeafe;
          display:flex;
          align-items:center;
          justify-content:center;
        }

        .content {
          flex:1;
        }

        .content h3 {
          margin:0 0 5px;
          font-size:15px;
        }

        .content p {
          margin:0 0 7px;
          color:#64748b;
          font-size:14px;
        }

        .content small {
          color:#94a3b8;
        }

        .dot {
          width:9px;
          height:9px;
          background:#2563eb;
          border-radius:50%;
        }
      `}</style>
    </div>
    <PartnerFooter/>
    </>
  );
}

export default PartnerNotifications;